export default __webpack_public_path__ + "static/radeec-9660a4f1d6f1f7e9464a211e592551bf.png";